// generated from 4_846 samples

import { z } from "zod";
import { common } from "../common";

export const subscriptionGroupStateChangedTriggerGetSchema = z.object({
  event_type: z.literal("TrackedUserBehavior::SubscriptionGroupStateChanged"),
  subscription_group: z.object({
    // null: 2 (0.04%)
    id: common.objectId.nullable(),
    // null: 2 (0.04%)
    name: z.string().nullable(),
  }),
  subscription_state: common.numericEnum([
    1, // 2_689 (55.49%)
    0, // 2_157 (44.51%)
  ]),
  subscription_type: z.enum([
    "email", // 3_217 (66.38%)
    "sms", // 1_477 (30.48%)
    "whatsApp", // 140 (2.89%)
    "line", // 12 (0.25%)
  ]),
  subscription_update_source: z.enum([
    "f", // 1_503 (31.02%)
    "r", // 1_223 (25.24%)
    "cs", // 690 (14.24%)
    "i", // 496 (10.24%)
    "s", // 392 (8.09%)
    "c", // 255 (5.26%)
    "oc", // 174 (3.59%)
    "sh", // 101 (2.08%)
    "pe", // 12 (0.25%)
  ]),
});
